import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {RepublicaMovilService} from '../../services/republica-movil.service';
import {MatStepper} from '@angular/material/stepper';
import {FormGroup, Validators} from '@angular/forms';
import {iccidValidator} from '../../../utils/validators/iccid-validator';
import * as moment from 'moment';
import {orderType} from 'src/app/shared/constantes';
import {RmMovilPackService} from '../../services/rm-movil-pack.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { DigoService } from 'src/app/services/digo.service';

@Component({
    selector: 'app-rm-movil-pack',
    templateUrl: './rm-movil-pack.component.html',
    styleUrls: ['./rm-movil-pack.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmMovilPackComponent implements OnInit, OnDestroy {
    @Input() index: number;
    @Input() formGroup: FormGroup;
    @Input() stepper: MatStepper;

    @Output() requestAddMobileLine = new EventEmitter();

    private stepperIndex: number;
    public typeOrder: string;
    public rateType: string;
    public rate: any;
    public typeOperation = 'registration';
    public portabilityTypeClient: string;
    public serviceProviders = [];
    public minDate: string;
    public maxDate: string;
    public rateFtth: any = null;
    public allowAddAdditionalLines = true;
    private allSubscription: Subscription[] = [];

    constructor(
        private rmService: RepublicaMovilService,
        private movilPackService: RmMovilPackService,
        private modalService: NgbModal,
        private digoService: DigoService
    ) {
    }

    ngOnInit(): void {
        this.minDate = moment().format('YYYY-MM-DD');
        this.maxDate = moment().add(30, 'days').format('YYYY-MM-DD');

        this.allSubscription.push(this.rmService.getTypeOrder()
            .subscribe((data: any) => {
                if (data != null) {
                    this.typeOrder = data;
                    this.stepperIndex = this.index + (this.typeOrder === orderType.CONVERGENT ? 1 : 0);
                    this.setRateType();
                }
            })
        );

        this.allSubscription.push(this.rmService.getServiceProviders()
            .subscribe((data: any) => {
                if (data != null) {
                    this.serviceProviders = data;
                }
            })
        );

        this.allSubscription.push(this.rmService.getRatesMobile()
            .subscribe((data: any) => {
                if (data != null && typeof data[this.index] !== 'undefined') {
                    this.rate = data[this.index];
                    this.formGroup.get('rate').patchValue(this.rate);
                } else {
                    this.rate = null;
                }
            })
        );

        this.allSubscription.push(this.rmService.getRateFtth()
            .subscribe((data: any) => {
                this.rateFtth = data;
            })
        );

        this.stepper.selectionChange
            .subscribe((data) => {
                if (this.stepperIndex === data.previouslySelectedIndex) {
                    if (this.validate()) {
                        this.rmService.setMobilePacks(this.index, this.formGroup.getRawValue());
                    }
                }
            });

        this.allSubscription.push(this.movilPackService.getAllowAddAdditionalLines()
            .subscribe((data: any) => {
                if (data != null) {
                    this.allowAddAdditionalLines = data;
                }
            })
        );

        if (this.formGroup.get('type_operation').value != null && this.formGroup.get('type_operation').value !== '') {
            this.changeTypeOperation(this.formGroup.get('type_operation').value);
        }

        if (this.formGroup.get('portability_type_client').value != null && this.formGroup.get('portability_type_client').value !== '') {
            this.changePortabilityTypeClient(this.formGroup.get('portability_type_client').value);
        }

        this.formGroup.statusChanges
            .subscribe(form => {
                if ((this.formGroup.get('rate').value !== null && this.formGroup.valid)) {
                    let itemsForms = this.rmService.getMobilePacksObject();
                    if (itemsForms && itemsForms.length) {
                        itemsForms.splice(this.index, 1, this.formGroup.getRawValue());
                    }
                    if (itemsForms && itemsForms.length > 1) {
                        this.evaluateICCID(itemsForms);
                        this.evaluateMSISDN(itemsForms);
                    }
                }
            });
    }

    setRateType() {
        if (this.typeOrder === orderType.CONVERGENT && this.index === 0) {
            this.rateType = 'ftth_mobile';
        } else {
            this.rateType = 'mobile';
        }
    }

    priceWithIVA(price: number): number {
        return price * 1.21;
    }

    changeTypeOperation(value) {
        this.typeOperation = value;

        if (this.typeOperation === 'portability') {
            this.formGroup.get('portability_phone').setValidators([
                Validators.required,
                Validators.pattern('[0-9 ]*'),
                Validators.minLength(9),
                Validators.maxLength(9)
            ]);
            this.formGroup.get('portability_type_client').setValidators(Validators.required);
            this.formGroup.get('portability_iccid').setValidators([Validators.required, iccidValidator(this.digoService)]);
            this.formGroup.get('portability_operator').setValidators(Validators.required);
        } else {
            this.formGroup.get('portability_phone').patchValue('');
            this.formGroup.get('portability_type_client').patchValue('');
            this.formGroup.get('portability_iccid').patchValue('');
            this.formGroup.get('portability_operator').patchValue('');
            this.formGroup.get('portability_date').patchValue('');

            this.formGroup.get('portability_phone').clearValidators();
            this.formGroup.get('portability_type_client').clearValidators();
            this.formGroup.get('portability_iccid').clearValidators();
            this.formGroup.get('portability_operator').clearValidators();
        }

        this.formGroup.get('portability_phone').updateValueAndValidity();
        this.formGroup.get('portability_operator').updateValueAndValidity();
        this.formGroup.get('portability_type_client').updateValueAndValidity();
        this.formGroup.get('portability_iccid').updateValueAndValidity();
    }

    changePortabilityTypeClient(value) {
        this.portabilityTypeClient = value;
        this.formGroup.get('portability_iccid').clearValidators();

        if (value === 'postpaid') {
            this.formGroup.get('portability_iccid').patchValue('');
            this.formGroup.get('portability_iccid').setValidators(iccidValidator(this.digoService));
        } else {
            this.formGroup.get('portability_iccid').setValidators([Validators.required, iccidValidator(this.digoService)]);
        }

        this.formGroup.get('portability_iccid').updateValueAndValidity();
    }

    validate(): boolean {
        this.formGroup.markAllAsTouched();
        this.formGroup.updateValueAndValidity();

        if (this.formGroup.valid) {
            return true;
        } else {
            const elements: any = document.getElementsByClassName('mat-input-element ng-invalid');

            if (elements.length > 0) {
                elements[0].focus();
            }

            return false;
        }
    }

    addMobileLine() {
        if (this.validate()) {
            this.requestAddMobileLine.emit();
            this.rmService.setMobilePacks(this.index, this.formGroup.getRawValue());
            this.stepper.next();
        }
    }

    changeRate() {
        if (this.typeOrder === orderType.CONVERGENT && this.index === 0) {
            this.rmService.setRateFtth(null);
            this.stepper.previous();
        } else {
            this.rate = null;
            this.formGroup.get('rate').patchValue(null);
        }
    }

    evaluateICCID(itemsForms: any[]) {
        const typeForms = itemsForms.filter(form => (form.portability_iccid !== '' && form.portability_type_client === 'prepaid' && form.type_operation === 'portability') || (form.iccid !== ''));
        if (typeForms && typeForms.length > 1) {
            let iccids: string[] = [];
            typeForms.map((form) => {
                if (form.iccid !== '') {
                    iccids.push(form.iccid);
                }
                if (form.portability_iccid !== '') {
                    iccids.push(form.portability_iccid);
                }
            });
            let unique = [...new Set(iccids)];
            if (unique.length < iccids.length) {
                // Buscamos cuales de los iccids es el repetido el campo que tenga ese valor es el que falla
                let conflictValue = [...new Set(iccids.filter((value, index, self) => self.indexOf(value) !== index))]
                if (this.formGroup.get('iccid').value !== '' && this.formGroup.get('iccid').value === conflictValue[0]) {
                    this.formGroup.controls['iccid'].setErrors({notmustMatch: true});
                }
                if (this.formGroup.get('portability_iccid').value !== '' && this.formGroup.get('portability_iccid').value === conflictValue[0]) {
                    this.formGroup.controls['portability_iccid'].setErrors({notmustMatch: true});
                }
            } else {
                if (this.formGroup.controls['iccid'].errors) {
                    this.formGroup.controls['iccid'].setErrors(null);
                }
                if (this.formGroup.controls['portability_iccid'].errors) {
                    this.formGroup.controls['portability_iccid'].setErrors(null);
                }
            }
        }
    }

    evaluateMSISDN(itemsForms: any[]) {
        const typeForms = itemsForms.filter(form => form.portability_phone !== '');
        if (typeForms && typeForms.length > 1) {
            let msisdn:string[] = [];
            typeForms.map((form) => {
                if (form.portability_phone !== '') {
                    msisdn.push(form.portability_phone);
                }
            });
            let unique = [...new Set(msisdn)];
            if (unique.length < msisdn.length) {
                // Buscamos cuales de los msisdn es el repetido el campo que tenga ese valor es el que falla
                let conflictValue = [...new Set(msisdn.filter((value, index, self) => self.indexOf(value) !== index))]
                if (this.formGroup.get('portability_phone').value !== '' && this.formGroup.get('portability_phone').value === conflictValue[0]) {
                    this.formGroup.controls['portability_phone'].setErrors({notmustMatch: true});
                }
            } else {
                if (this.formGroup.controls['portability_phone'].errors) {
                    this.formGroup.controls['portability_phone'].setErrors(null);
                }
            }
        }        
    }

    next() {
        if (this.validate()) {
            this.rmService.setMobilePacks(this.index, this.formGroup.getRawValue());
            this.stepper.next();
        }
    }

    prev() {
        this.stepper.previous();
    }

    openModalICCID(content) {
        this.modalService.open(content, {size: 'md', centered: true});
    }

    addPrefix() {
        if (this.formGroup.get('iccid').value === '') {
            this.formGroup.get('iccid').patchValue('893401');
        }
    }

    withoutWeekendFilter = (d: any): boolean => {
        const holidayList = [
            moment("07/12/2020", "DD/MM/YYYY").toDate(),
            moment("08/12/2020", "DD/MM/YYYY").toDate(),
            moment("25/12/2020", "DD/MM/YYYY").toDate(),
            moment("01/01/2021", "DD/MM/YYYY").toDate(),
            moment("06/01/2021", "DD/MM/YYYY").toDate()
        ]
        const time = d.toDate();
        return d.day() !== 0 && d.day() !== 6 && !holidayList.find(x => x.toDateString() == time.toDateString());
    }

    ngOnDestroy() {
        this.formGroup.reset();
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
